'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCheckDot, iconCheckDotTag } from '@ni/nimble-components/dist/esm/icons/check-dot';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCheckDot };
export { iconCheckDotTag };
export const NimbleIconCheckDot = wrap(IconCheckDot);